module.exports = __webpack_public_path__ + "static/mr-press-31-13431f1523ccfa334c605878f0076bfa.jpg";